import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Cs from "../../services/CommonService";
import CourseCompletionService from './CourseCompletionService';
import useDownloadVerification from '../Common/CertificateDownload';

const CertificatePublicView = () => {
  const { id } = useParams();
  const [record, setRecord]           = useState(null);
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState('');
  const [downloading, setDownloading] = useState(false);

  const { cardRef, downloadCard } = useDownloadVerification({
    filename:      `Verification_${record?.data?.name?.replace(/\s+/g, '_') || 'certificate'}`,
    hideElementId: 'cert-download-btn'
  });

  useEffect(() => { fetchRecord(); }, [id]);

  const fetchRecord = async () => {
    setLoading(true);
    try {
      const { status, data } = await CourseCompletionService.getPublicRecord(id);
      if (status === 200) {
        setRecord(data);
      } else {
        setError('Certificate not found. This QR code may be invalid.');
      }
    } catch (e) {
      setError('Unable to load certificate details.');
    }
    setLoading(false);
  };

  const handleDownload = async (e) => {
    setDownloading(true);
    try {
      await downloadCard(e);
    } catch (err) {
      console.error('Download failed:', err);
      alert('Failed to download. Please try again.');
    }
    setDownloading(false);
  };

  if (loading) {
    return (
      <div className="flex aligncenter justifycenter mih-100vh bg-grey-1">
        <div className="text-center">
          <i className="fas fa-spinner fa-spin f40 text-green" />
          <p className="text-gray font-14 m-t-10">Verifying certificate...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex aligncenter justifycenter mih-100vh bg-grey-1 p-20">
        <div className="bg-white brd-10 shadow-small p-20 text-center mxw-420">
          <i className="fas fa-times-circle f40 lred" />
          <h3 className="fw700 f18 m-t-10 m-b-5">Invalid Certificate</h3>
          <p className="text-gray font-14">{error}</p>
        </div>
      </div>
    );
  }

  const data = record?.data || {};

  return (
    <div className="flex aligncenter justifycenter mih-100vh bg-grey-1 p-20">
      <div id="cert-verification-card" ref={cardRef} className="bg-white brd-10 shadow-small p-20 w-100p mxw-420">

        <div className="text-center m-b-20">
          <img src="/images/logo/logo_180.png" alt="IITM Global" style={{ width: '80px', height: '80px', objectFit: 'contain' }}/>
          <h2 className="fw700 f18 m-t-10 m-b-5">Certificate Verification</h2>
          <p className="text-gray font-14 m0">Issued by IITM Global</p>
          <div className="flex aligncenter justifycenter gap-10 m-t-10">
            <span className="bg-green white brd-30 p-5-10 font-12 fw500">
              <i className="fas fa-check-circle m-r-5" />Verified
            </span>
            <button
              id="cert-download-btn"
              onClick={handleDownload}
              disabled={downloading}
              className="bg-highlight white brd-30 p-5-10 font-12 fw500 no-border pointer flex aligncenter gap-5">
              <i className="fas fa-download m-r-5" />
              {downloading ? 'Downloading...' : 'Download'}
            </button>
          </div>
        </div>

        <div className="br-btm-grey m-b-15" />

        <div className="flex coldir gap-10">
          <DetailRow icon="fas fa-user"           label="Name"               value={data.name} />
          <DetailRow icon="fas fa-graduation-cap" label="Course"             value={data.course_title} />
          <DetailRow icon="fas fa-id-card"        label="Roll Number"        value={data.roll_number} />
          <DetailRow icon="fas fa-envelope"       label="Email"              value={data.email} />
          <DetailRow icon="fas fa-phone"          label="Mobile"             value={data.mobile} />
          <DetailRow icon="fas fa-calendar" label="Duration"
            value={data.start_month && data.end_month ? `${data.start_month} – ${data.end_month}`: data.start_month || '—'}/>
          <DetailRow icon="fas fa-hashtag" label="Certificate Number" value={data.certificate_number} />
          <DetailRow icon="fas fa-clock" label="Issued On" value={Cs.formatUpdateDate(record?.created_at, 'MMM D, YYYY')} />
        </div>

        <div className="br-top-grey m-t-20 p-t-10 flex aligncenter justspacebetween">
          <span className="fw700 font-12"
            style={{ color: '#00a86b', letterSpacing: '1px' }}>
            CUEDLINK
          </span>
          <p className="text-gray font-12">
            <i className="fas fa-lock m-r-5" />
            C ID: <span className="fw500 black">{record?.record_id}</span>
          </p>
        </div>

      </div>
    </div>
  );
};

const DetailRow = ({ icon, label, value }) => (
  <div className="flex aligncenter gap-10 bg-grey-1 brd-5 p-10">
    <div className="flex aligncenter justifycenter bg-green white brd-5"
      style={{ width: '32px', height: '32px', flexShrink: 0 }}>
      <i className={`${icon} font-12`} />
    </div>
    <div className="flex coldir">
      <span className="text-gray font-12">{label}</span>
      <span className="fw500 font-14 black">{value || '—'}</span>
    </div>
  </div>
);

export default CertificatePublicView;